import { render, staticRenderFns } from "./ViewWithdraws.vue?vue&type=template&id=12025c72"
import script from "./ViewWithdraws.vue?vue&type=script&lang=js"
export * from "./ViewWithdraws.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports